import React from 'react';

export default class TournamentForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                name: "",
                id: '',
                created: '',
                type_tournament: '',
                type_tournament_name: '',
                tournament: ''
            }
        };
    }    

    componentWillMount(){
        let st = {...this.props.selected}
        if(localStorage.getItem("rol")=="admin")
            st.tournament = 'futrapido'
        else
            st.tournament = localStorage.getItem("rol")
        this.setState({selected: st});
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            this.props.save(this.state.selected)
        }
    }

    render(){
        return(
            <div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Nombre Torneo</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="text" autoFocus onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Torneo" defaultValue={this.state.selected.name} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.name = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Tipo Torneo</label>
                    </div>
                    <div className="field-body">
                        <select
                            onKeyPress={(e) => this.handleKeyPress(e)}
                            className="input"
                            name="tournament"
                            onChange={(e) => {
                                let state = {...this.state};
                                state.selected.tournament = e.currentTarget.value;
                                state.selected.type_tournament_name = "Fútbol rápido";
                            }}
                        >
                            {(localStorage.getItem("rol")=="futrapido" || localStorage.getItem("rol")=="admin") && 
                                <option key={1} defaultValue="1" value='futrapido' selected={1==this.state.selected.tournament ? "selected" :"" }>
                                    Fútbol rápido
                                </option>
                            }
                            {(localStorage.getItem("rol")=="fut7" || localStorage.getItem("rol")=="admin") && 
                                <option key={2} defaultValue="2" value='fut7' selected={2==this.state.selected.tournament ? "selected" :"" }>
                                    Fútbol 7
                                </option>
                            }
                            {(localStorage.getItem("rol")=="fut6" || localStorage.getItem("rol")=="admin") && 
                                <option key={3} defaultValue="3" value='fut6' selected={3==this.state.selected.tournament ? "selected" :"" }>
                                    Fútbol 6
                                </option>
                            }
                        </select>
                    </div>
                </div>
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        <button className="button is-success" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/tournament/form.js